/* eslint-disable */
"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useMemo, useEffect, useCallback } from "react";
import { colorSettingDetection } from "../../utils/functions";
import { getDropdownValues, getDependentDropdownValues, getSelectedItem, getMetaLocatorUrl } from "./LayoutMetalocatorMethods";
import { CommonDescription } from "../../component/CommonDescription/CommonDescription";
import { useConsent } from "@/components/client/Consent/ConsentProvider";
import useCheckOneTrust from "@/components/client/PromotionBanner/useCheckOneTrust";
import Cookies from "js-cookie";
import "./LayoutMetalocator.css";
import { layoutHeaderClasses, layoutSubheaderClasses, layoutEyebrowClasses } from "@/components/tailwindHelpers";
export interface MetaLocatorDropdownItem {
  title: string;
  displayValue: string;
  metaLocatorInstance?: string;
  fallBackText?: string;
  dependentDropDowns?: MetaLocatorDropdownItem[];
}
export interface MetaLocatorContent {
  eyebrow?: string;
  header?: string;
  subheader?: string;
  description?: string;
  industryDropDowns?: MetaLocatorDropdownItem[];
  industryHelperText?: string;
  categoryHelperText?: string;
  formPromptText?: string;
  metaLocatorInstance?: string;
  fallbackContent?: string;
  showDropdowns?: boolean;
  firstSelectLabel?: string;
  secondSelectLabel?: string;
}
export interface LayoutMetalocatorProps {
  content: MetaLocatorContent;
  headerElement?: "h1" | "h2";
  presetTheme?: "t2-theme-one" | "t2-theme-two" | "t2-theme-three" | "t2-theme-four" | "t2-theme-five" | "t2-theme-six" | "t2-theme-seven";
  isWrapped?: boolean;
  marginLeft?: boolean;
  className?: string;
  metaLocatorLanguage?: string;
}
export const LayoutMetalocator = t0 => {
  const $ = _c(115);
  const {
    content,
    headerElement: t1,
    presetTheme: t2,
    isWrapped: t3,
    marginLeft: t4,
    className: t5,
    metaLocatorLanguage
  } = t0;
  const headerElement = t1 === undefined ? "h2" : t1;
  const presetTheme = t2 === undefined ? "t2-theme-one" : t2;
  const isWrapped = t3 === undefined ? true : t3;
  const marginLeft = t4 === undefined ? false : t4;
  const className = t5 === undefined ? "" : t5;
  const {
    industryDropDowns: t6
  } = content;
  let t7;
  if ($[0] !== t6) {
    t7 = t6 === undefined ? [] : t6;
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const industryDropDowns = t7;
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [isFormRendered, setIsFormRendered] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [urlTagIds, setUrlTagIds] = useState();
  const {
    hasConsent
  } = useConsent();
  const {
    hasAcceptedOneTrust
  } = useCheckOneTrust(Cookies);
  const hasCookieConsent = hasConsent || hasAcceptedOneTrust;
  let t8;
  if ($[2] !== industryDropDowns) {
    t8 = getDropdownValues(industryDropDowns);
    $[2] = industryDropDowns;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const industryDropDownValues = t8;
  let t9;
  if ($[4] !== industryDropDowns || $[5] !== selectedIndustry) {
    t9 = getDependentDropdownValues(industryDropDowns, selectedIndustry);
    $[4] = industryDropDowns;
    $[5] = selectedIndustry;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  const categoryDropDownValues = t9;
  let t10;
  if ($[7] !== categoryDropDownValues || $[8] !== industryDropDowns || $[9] !== selectedCategory || $[10] !== selectedIndustry) {
    t10 = getSelectedItem(industryDropDowns, selectedIndustry, selectedCategory, categoryDropDownValues);
    $[7] = categoryDropDownValues;
    $[8] = industryDropDowns;
    $[9] = selectedCategory;
    $[10] = selectedIndustry;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const selectedItem = t10;
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = value => {
      setSelectedIndustry(value);
      setSelectedCategory("");
      setHasSubmitted(false);
    };
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const handleIndustryChange = t11;
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = value_0 => {
      setSelectedCategory(value_0);
      setHasSubmitted(false);
    };
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const handleCategoryChange = t12;
  let t13;
  if ($[14] !== selectedItem) {
    t13 = () => {
      if (selectedItem) {
        setHasSubmitted(true);
      }
    };
    $[14] = selectedItem;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const handleSubmit = t13;
  let t14;
  if ($[16] !== categoryDropDownValues.length || $[17] !== handleSubmit || $[18] !== selectedCategory || $[19] !== selectedIndustry || $[20] !== selectedItem) {
    t14 = () => {
      if (selectedItem && selectedIndustry && (selectedCategory || categoryDropDownValues.length === 0)) {
        const timer = setTimeout(() => {
          handleSubmit();
        }, 100);
        return () => clearTimeout(timer);
      }
    };
    $[16] = categoryDropDownValues.length;
    $[17] = handleSubmit;
    $[18] = selectedCategory;
    $[19] = selectedIndustry;
    $[20] = selectedItem;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== categoryDropDownValues || $[23] !== handleSubmit || $[24] !== selectedCategory || $[25] !== selectedIndustry || $[26] !== selectedItem) {
    t15 = [selectedItem, selectedIndustry, selectedCategory, categoryDropDownValues, handleSubmit];
    $[22] = categoryDropDownValues;
    $[23] = handleSubmit;
    $[24] = selectedCategory;
    $[25] = selectedIndustry;
    $[26] = selectedItem;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  useEffect(t14, t15);
  let t16;
  let t17;
  if ($[28] !== content) {
    t16 = () => {
      if (content) {
        setIsFormRendered(true);
      } else {
        setIsFormRendered(false);
      }
    };
    t17 = [content];
    $[28] = content;
    $[29] = t16;
    $[30] = t17;
  } else {
    t16 = $[29];
    t17 = $[30];
  }
  useEffect(t16, t17);
  let t18;
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => {
      const params = new URLSearchParams(window.location.search);
      for (const [, value_1] of params) {
        const ids = value_1.split(",").map(_temp).filter(Boolean);
        if (ids.length > 0) {
          setUrlTagIds(ids);
          break;
        }
      }
    };
    t19 = [];
    $[31] = t18;
    $[32] = t19;
  } else {
    t18 = $[31];
    t19 = $[32];
  }
  useEffect(t18, t19);
  let t20;
  let t21;
  if ($[33] !== isFormRendered) {
    t20 = () => {
      if (isFormRendered) {
        const timer_0 = setTimeout(() => {
          setIsInitialLoad(false);
        }, 150);
        return () => clearTimeout(timer_0);
      }
    };
    t21 = [isFormRendered];
    $[33] = isFormRendered;
    $[34] = t20;
    $[35] = t21;
  } else {
    t20 = $[34];
    t21 = $[35];
  }
  useEffect(t20, t21);
  const hasDropDowns = categoryDropDownValues.length > 0;
  let t22;
  if ($[36] !== presetTheme) {
    t22 = colorSettingDetection(presetTheme);
    $[36] = presetTheme;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  const backgroundStyle = t22;
  const wrapperClasses = `${isWrapped ? "w-full px-5 lg:px-20 m-auto max-w-[1440px]" : ""}`;
  const marginLeftStyle = marginLeft ? "ml-20" : "";
  if (!isFormRendered) {
    return null;
  }
  let t23;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = ["t2-theme-three", "t2-theme-four", "t2-theme-five", "t2-theme-seven"];
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  const isDark = t23.includes(presetTheme);
  const selectLabelClasses = `mb-3 text-xs not-italic font-extrabold leading-normal tracking-[0.05em] block uppercase ${isDark ? "text-white" : "text-gray-m9"}`;
  const t24 = `t2-layout-metalocator ${className}`;
  const t25 = `t2-meta-locator__themed-zone pt-[100px] pb-[60px] ${presetTheme}`;
  const t26 = `relative ${backgroundStyle} ${marginLeftStyle}`;
  let t27;
  if ($[39] !== content.eyebrow || $[40] !== isDark) {
    t27 = content.eyebrow && <div className={`${layoutEyebrowClasses} ${isDark ? "!text-yellow-m10" : ""}`}>{content.eyebrow}</div>;
    $[39] = content.eyebrow;
    $[40] = isDark;
    $[41] = t27;
  } else {
    t27 = $[41];
  }
  let t28;
  if ($[42] !== content.header || $[43] !== headerElement || $[44] !== isDark) {
    t28 = content.header && (headerElement === "h1" ? <h1 className={`${layoutHeaderClasses} ${isDark ? "!text-white" : ""}`}>{content.header}</h1> : <h2 className={`${layoutHeaderClasses} ${isDark ? "!text-white" : ""}`}>{content.header}</h2>);
    $[42] = content.header;
    $[43] = headerElement;
    $[44] = isDark;
    $[45] = t28;
  } else {
    t28 = $[45];
  }
  let t29;
  if ($[46] !== content.subheader || $[47] !== isDark) {
    t29 = content.subheader && <div className={`${layoutSubheaderClasses} ${isDark ? "!text-white" : ""}`}>{content.subheader}</div>;
    $[46] = content.subheader;
    $[47] = isDark;
    $[48] = t29;
  } else {
    t29 = $[48];
  }
  let t30;
  if ($[49] !== content.description || $[50] !== isDark) {
    t30 = content.description && <CommonDescription description={content.description} className={`t2-layout__description ${isDark ? "!text-white" : ""}`} />;
    $[49] = content.description;
    $[50] = isDark;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== t27 || $[53] !== t28 || $[54] !== t29 || $[55] !== t30) {
    t31 = <div className="t2-header-area">{t27}{t28}{t29}{t30}</div>;
    $[52] = t27;
    $[53] = t28;
    $[54] = t29;
    $[55] = t30;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] !== categoryDropDownValues || $[58] !== content.categoryHelperText || $[59] !== content.firstSelectLabel || $[60] !== content.industryHelperText || $[61] !== content.secondSelectLabel || $[62] !== content.showDropdowns || $[63] !== hasDropDowns || $[64] !== industryDropDownValues || $[65] !== isInitialLoad || $[66] !== selectLabelClasses || $[67] !== selectedCategory || $[68] !== selectedIndustry) {
    t32 = content.showDropdowns !== false && <div className={`flex gap-6 pt-8 max-sm:flex-col max-sm:gap-4 ${isInitialLoad ? "opacity-70 translate-y-[5px] transition-[opacity,transform] duration-300 ease-in-out" : ""}`}><div className="flex-1 min-w-0 max-w-[350px]"><label htmlFor="industry-select" className={selectLabelClasses}>{content.firstSelectLabel || "Industry"}</label><select id="industry-select" name="industry-select" className="w-full rounded-xl border border-[#f3f3f7] text-base font-normal leading-6 tracking-[0.16px] shadow-[0_2px_4px_rgba(0,0,0,0.05)] bg-white min-h-14 px-5 py-3.5 cursor-pointer appearance-none transition-all duration-200 ease-in-out hover:border-gray-m5 hover:shadow-[0_4px_8px_rgba(0,0,0,0.08)] focus:outline-none focus:border-blue-trmb focus:shadow-[0_0_0_3px_rgba(0,99,163,0.15)] disabled:bg-gray-m1 disabled:text-gray-m5 disabled:cursor-not-allowed disabled:border-[#f3f3f7] disabled:shadow-none" value={selectedIndustry} onChange={e => handleIndustryChange(e.target.value)}><option value="">{content.industryHelperText}</option>{industryDropDownValues.map(_temp2)}</select></div><div className={`flex-1 min-w-0 max-w-[500px] transition-[visibility,opacity] duration-300 ease-in-out ${hasDropDowns ? "visible opacity-100 block" : "invisible opacity-0 hidden"}`}><label htmlFor="category-select" className={selectLabelClasses}>{content.secondSelectLabel || "Product"}</label><select id="category-select" name="category-select" className="w-full rounded-xl border border-[#f3f3f7] text-base font-normal leading-6 tracking-[0.16px] shadow-[0_2px_4px_rgba(0,0,0,0.05)] bg-white min-h-14 px-5 py-3.5 cursor-pointer appearance-none transition-all duration-200 ease-in-out hover:border-gray-m5 hover:shadow-[0_4px_8px_rgba(0,0,0,0.08)] focus:outline-none focus:border-blue-trmb focus:shadow-[0_0_0_3px_rgba(0,99,163,0.15)] disabled:bg-gray-m1 disabled:text-gray-m5 disabled:cursor-not-allowed disabled:border-[#f3f3f7] disabled:shadow-none" value={selectedCategory} onChange={e_0 => handleCategoryChange(e_0.target.value)} disabled={!selectedIndustry}><option value="">{content.categoryHelperText}</option>{categoryDropDownValues.map(_temp3)}</select></div></div>;
    $[57] = categoryDropDownValues;
    $[58] = content.categoryHelperText;
    $[59] = content.firstSelectLabel;
    $[60] = content.industryHelperText;
    $[61] = content.secondSelectLabel;
    $[62] = content.showDropdowns;
    $[63] = hasDropDowns;
    $[64] = industryDropDownValues;
    $[65] = isInitialLoad;
    $[66] = selectLabelClasses;
    $[67] = selectedCategory;
    $[68] = selectedIndustry;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] !== t26 || $[71] !== t31 || $[72] !== t32) {
    t33 = <div className={t26}>{t31}{t32}</div>;
    $[70] = t26;
    $[71] = t31;
    $[72] = t32;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] !== t33 || $[75] !== wrapperClasses) {
    t34 = <div className={wrapperClasses}>{t33}</div>;
    $[74] = t33;
    $[75] = wrapperClasses;
    $[76] = t34;
  } else {
    t34 = $[76];
  }
  let t35;
  if ($[77] !== t25 || $[78] !== t34) {
    t35 = <div className={t25}>{t34}</div>;
    $[77] = t25;
    $[78] = t34;
    $[79] = t35;
  } else {
    t35 = $[79];
  }
  let t36;
  if ($[80] !== content.formPromptText || $[81] !== content.showDropdowns || $[82] !== hasSubmitted || $[83] !== marginLeftStyle || $[84] !== selectedCategory || $[85] !== selectedIndustry) {
    t36 = content.showDropdowns !== false && content.formPromptText && <section className={`t2-meta-locator__form-prompt flex items-center min-h-5 relative mt-20 ${marginLeftStyle}`}><div className={`${"text-blue-trmb uppercase text-lg not-italic font-bold leading-7 tracking-[1.44px] max-sm:text-sm max-sm:leading-[1.125rem] max-sm:tracking-[0.7px] [&_h2]:text-blue-trmb [&_h2]:text-[inherit] [&_h2]:font-[inherit] [&_h2]:m-0 [&_h3]:text-gray-m9 [&_h3]:text-[2.5rem] [&_h3]:font-light [&_h3]:leading-[1.2] [&_h3]:tracking-[0.8px] [&_h3]:m-0 [&_h3]:capitalize max-sm:[&_h3]:text-[2rem]"} ${hasSubmitted ? "hidden" : ""}`}>{content.formPromptText}</div><div className={`${"text-blue-trmb uppercase text-lg not-italic font-bold leading-7 tracking-[1.44px] max-sm:text-sm max-sm:leading-[1.125rem] max-sm:tracking-[0.7px] [&_h2]:text-blue-trmb [&_h2]:text-[inherit] [&_h2]:font-[inherit] [&_h2]:m-0 [&_h3]:text-gray-m9 [&_h3]:text-[2.5rem] [&_h3]:font-light [&_h3]:leading-[1.2] [&_h3]:tracking-[0.8px] [&_h3]:m-0 [&_h3]:capitalize max-sm:[&_h3]:text-[2rem]"} ${hasSubmitted ? "block" : "hidden"}`}><h2>{selectedIndustry}</h2>{selectedCategory && <h3>{selectedCategory}</h3>}</div></section>;
    $[80] = content.formPromptText;
    $[81] = content.showDropdowns;
    $[82] = hasSubmitted;
    $[83] = marginLeftStyle;
    $[84] = selectedCategory;
    $[85] = selectedIndustry;
    $[86] = t36;
  } else {
    t36 = $[86];
  }
  let t37;
  if ($[87] !== content.fallbackContent || $[88] !== content.metaLocatorInstance || $[89] !== content.showDropdowns || $[90] !== hasSubmitted || $[91] !== selectedItem?.fallBackText || $[92] !== selectedItem?.metaLocatorInstance) {
    t37 = content.showDropdowns !== false && hasSubmitted && !selectedItem?.metaLocatorInstance && !content.metaLocatorInstance && <div className="max-h-[250rem] visible overflow-hidden mt-20"><div className="p-20 bg-gray-m2 rounded-lg text-center">{selectedItem?.fallBackText || content.fallbackContent}</div></div>;
    $[87] = content.fallbackContent;
    $[88] = content.metaLocatorInstance;
    $[89] = content.showDropdowns;
    $[90] = hasSubmitted;
    $[91] = selectedItem?.fallBackText;
    $[92] = selectedItem?.metaLocatorInstance;
    $[93] = t37;
  } else {
    t37 = $[93];
  }
  const t38 = `mt-20 ${marginLeftStyle}`;
  let t39;
  if ($[94] !== content.metaLocatorInstance || $[95] !== hasCookieConsent || $[96] !== hasSubmitted || $[97] !== metaLocatorLanguage || $[98] !== selectedItem?.metaLocatorInstance || $[99] !== urlTagIds) {
    t39 = (content.metaLocatorInstance || hasSubmitted && selectedItem?.metaLocatorInstance) && (hasCookieConsent ? <iframe className="metalocator_iframe" src={getMetaLocatorUrl(content.metaLocatorInstance || selectedItem?.metaLocatorInstance || "", metaLocatorLanguage || "en-US (3)", urlTagIds)} /> : <div className="p-20 bg-gray-m2 rounded-lg text-center text-gray-m9 text-base leading-6"><p>Please accept cookies to use the dealer locator.</p></div>);
    $[94] = content.metaLocatorInstance;
    $[95] = hasCookieConsent;
    $[96] = hasSubmitted;
    $[97] = metaLocatorLanguage;
    $[98] = selectedItem?.metaLocatorInstance;
    $[99] = urlTagIds;
    $[100] = t39;
  } else {
    t39 = $[100];
  }
  let t40;
  if ($[101] !== t39) {
    t40 = <div className="w-full relative">{t39}</div>;
    $[101] = t39;
    $[102] = t40;
  } else {
    t40 = $[102];
  }
  let t41;
  if ($[103] !== t38 || $[104] !== t40) {
    t41 = <div className={t38}>{t40}</div>;
    $[103] = t38;
    $[104] = t40;
    $[105] = t41;
  } else {
    t41 = $[105];
  }
  let t42;
  if ($[106] !== t36 || $[107] !== t37 || $[108] !== t41 || $[109] !== wrapperClasses) {
    t42 = <div className="pt-5 pb-[100px]"><div className={wrapperClasses}>{t36}{t37}{t41}</div></div>;
    $[106] = t36;
    $[107] = t37;
    $[108] = t41;
    $[109] = wrapperClasses;
    $[110] = t42;
  } else {
    t42 = $[110];
  }
  let t43;
  if ($[111] !== t24 || $[112] !== t35 || $[113] !== t42) {
    t43 = <div data-testid="layout-meta-locator" className={t24}>{t35}{t42}</div>;
    $[111] = t24;
    $[112] = t35;
    $[113] = t42;
    $[114] = t43;
  } else {
    t43 = $[114];
  }
  return t43;
};
function _temp(id) {
  return id.trim();
}
function _temp2(value_2, index) {
  return <option key={`industry-${index}`} value={value_2}>{value_2}</option>;
}
function _temp3(value_3, index_0) {
  return <option key={`category-${index_0}`} value={value_3}>{value_3}</option>;
}